// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAbortError = (err: any): boolean => {
	if (!err) return false;

	// 1. Check if it's a string message
	if (typeof err === "string") {
		const s = err.toLowerCase();
		return s.includes("signal is aborted without reason") || s.includes("aborted");
	}

	// 2. Check standard error properties (name, message, code)
	const name = err.name?.toLowerCase?.() || "";
	const message = err.message?.toLowerCase?.() || "";
	const code = String(err.code || "").toLowerCase();

	if (name === "aborterror") return true;
	if (code === "abort_err") return true;
	if (message.includes("aborted")) return true;

	// 3. Check Apollo/Network specific structures
	if (err.networkError) {
		if (Array.isArray(err.networkError)) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			return err.networkError.some((e: any) => isAbortError(e));
		}
		if (isAbortError(err.networkError)) return true;
	}

	// 4. Check nested properties (cause, error)
	if (err.cause && isAbortError(err.cause)) return true;
	if (err.error && isAbortError(err.error)) return true;

	// 5. Check if it's an array of errors itself
	if (Array.isArray(err)) {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		return err.some((e: any) => isAbortError(e));
	}

	return false;
};
